/* eslint-disable @typescript-eslint/no-explicit-any */
import { TableRow } from "../shared";

interface DynamicTableBodyProps {
  rows: any[];
  prepareRow: (row: any) => void;
  getTableBodyProps: () => any;
  isShowDecoratorColor: boolean;
  isGroupedMode: boolean;
  onRenderConfig?: (original: any) => React.ReactNode;
  loading?: boolean;
}

export const DynamicTableBody = ({
  rows,
  prepareRow,
  getTableBodyProps,
  isShowDecoratorColor,
  isGroupedMode,
  onRenderConfig,
  loading,
}: DynamicTableBodyProps) => {
  const showConfigColumn = !isGroupedMode && !!onRenderConfig;

  return (
    <div className="tbody" {...getTableBodyProps()}>
      {!loading &&
        rows.map((row: any, i: number) => (
          <TableRow
            key={row.id ?? i}
            row={row}
            rowIndex={i}
            prepareRow={prepareRow}
            isShowDecoratorColor={isShowDecoratorColor}
            showConfigColumn={showConfigColumn}
            onRenderConfig={onRenderConfig}
            isGroupedMode={isGroupedMode}
            simplified
          />
        ))}
    </div>
  );
};
